// mantine
import { Button, TextInput, UnstyledButton } from '@mantine/core';
// utils
import { useFormik } from 'formik';
import { processFormData } from '@newo/toolkit/bff';
import type { IRunnerType, TSkill, TSkillData } from '@newo/api/gateway';
import validationSchema from '@/modules/Designer/components/Skills/components/AddSkillForm/AddSkillForm.schema.ts';
import { DEFAULT_MODEL } from '@/const';

interface AddSkillFormProps {
    skill?: TSkill;
    defaultRunnerType?: IRunnerType;
    onCancel?: () => void;
    onSubmit: (data: TSkillData) => Promise<unknown>;
}

const AddSkillForm = ({
    skill,
    defaultRunnerType,
    onCancel,
    onSubmit
}: AddSkillFormProps) => {
    const initialValues: TSkillData = {
        title: skill?.title ?? '',
        idn: skill?.idn ?? '',
        prompt_script: skill?.prompt_script ?? '',
        runner_type: skill?.runner_type ?? defaultRunnerType ?? 'nsl',
        model: skill?.model ?? DEFAULT_MODEL,
        path: skill?.path ?? '',
        parameters: skill?.parameters ?? []
    };
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (formData) => {
            const data = processFormData(formData);
            try {
                await onSubmit(data);
                formik.setSubmitting(false);
                onCancel?.();
            } catch (error) {
                formik.setSubmitting(false);
                console.error(error);
            }
        }
    });
    const handleCancel = () => {
        onCancel?.();
    };

    return (
        <form
            autoComplete="off"
            className="flex flex-col gap-3"
            onSubmit={formik.handleSubmit}
        >
            <TextInput
                withAsterisk
                error={
                    formik.touched.idn && formik.values.idn
                        ? formik.errors.idn
                        : undefined
                }
                label="Skill Idn"
                name="idn"
                placeholder="Skill Idn"
                value={formik.values.idn}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
            />
            <TextInput
                error={
                    formik.touched.title && formik.values.title
                        ? formik.errors.title
                        : undefined
                }
                label="Skill title"
                name="title"
                placeholder="Skill title"
                value={formik.values.title ?? ''}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
            />
            <div className="flex justify-between gap-2">
                <UnstyledButton
                    className="text-xs text-gray-6"
                    onClick={handleCancel}
                >
                    Cancel
                </UnstyledButton>
                <Button
                    disabled={
                        !formik.dirty || !formik.isValid || formik.isSubmitting
                    }
                    size="xs"
                    type="submit"
                >
                    Create
                </Button>
            </div>
        </form>
    );
};

export default AddSkillForm;
